export default __webpack_public_path__ + "static/media/digiSuccess.7da0159a.png";